import { HTMLAttributes } from 'react';

export function DescriptionText({
  children,
}: HTMLAttributes<HTMLParagraphElement>) {
  return <p className="text-sm xl:max-w-96">{children}</p>;
}
